import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./RequestsForProposalOverviewPage.less');

const RequestsForProposalPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/buyer/sourcing/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
	];

	return (
		<>
			<Route
				path="/buyer/requestsForProposal/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/buyer/requestsForProposal/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Requests for Proposal"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="requestsForProposalPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	requestsForProposal: state.requests_for_proposal,
});

export default withRouter<any, any>(connect(mapStateToProps)(RequestsForProposalPage));
